import { type UseQueryResult, useQuery } from 'react-query';
import {
  NoticeService,
  StaticStatusDropdownService,
} from '@wealthlane/api-services/wealthlane-award-service';

const useGetGrantAcceptanceTemplateVariables = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  enabled = true
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Array<string> | undefined,
  unknown
> => {
  const grantAcceptanceTemplateVariables = useQuery(
    ['getGrantAcceptanceTemplateVariables'],
    async () => {
      return await handleRequest(
        StaticStatusDropdownService.getApiAwardApiAppStaticStatusDropdownGrantAgreementTemplateConstDropdown()
      );
    },
    {
      enabled,
      staleTime: 0,
      refetchOnMount: 'always',
    }
  );

  return grantAcceptanceTemplateVariables;
};

export default useGetGrantAcceptanceTemplateVariables;
